import generalSection from "../_section/section.class";
import {adminPayslipUpload, userPayslipUpload} from "./upload";
import DataForm from "./DataForm";
import ApplicationForm from "./ApplicationForm";
import problem from "../_section/section-problem.class";
import {Frequencies} from "../../../../../../models";
import dayjs from "dayjs";

export class userPayslipSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userPayslipUpload);
        // Add missing date error

    }
}

export class adminPayslipSection extends userPayslipSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminPayslipUpload);
        this.useStatementAlignmentDateToExpire = false
        this.sortByDateProp('documentDate')
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm;
        this.sortByDateProp('documentDate')
        this.setProblems(this.getProblems())

    }

    payslipsInMonths = (months, frequency) => {
        const days = months * 31;

        if (frequency === Frequencies.WEEKLY)
            return Math.floor((days - 1) / 7) + 1;

        if (frequency === Frequencies.FORTNIGHTLY)
            return Math.floor((days - 1) / 14) + 1;

        if (frequency === Frequencies.MONTHLY)
            return months;

        return 0;
    };

    getProblems() {
        const problems = this.problemsList.universalVerifiedUploadProblems();
        if (!problems.length) {
            if (!this.data?.payFrequency) {
                problems.push(new problem({
                        type: "BUNDLE",
                        title: 'Pay Frequency not set',
                        message: 'Pay Frequency missing from application',
                    }
                ))
            } else {
                const activeUploads = this.uploads.filter(it => it.isActive && it.values.documentDate && it.isVerifiable);
                //1. Find duplicate uploads
                const documentDates = activeUploads.map(it => it.values.documentDate.format('YYYY-MM-DD'));
                const duplicateDates = new Set(documentDates).size !== activeUploads.length;
                if (duplicateDates) {
                    problems.push(new problem({
                        type: "DATA",
                        title: 'Duplicate Payslip Dates',
                        message: 'There are multiple payslips with the same date',
                        userMessage: 'Please check the payslips dates'
                    }))
                }

                //2. Check if there are missing payslips between the most recent and now
                const mostRecentPayslipUpload = activeUploads.reduce((latest, upload) => {
                    const uploadDate = upload.values.documentDate;
                    return (!latest || uploadDate.isAfter(latest.values.documentDate)) ? upload : latest;
                }, null);
                const today = dayjs()
                const missingPayslipsBetweenMostRecentAndNow = (() => {
                    const last = mostRecentPayslipUpload.values.documentDate;

                    const jumps =
                        this.data.payFrequency === Frequencies.WEEKLY
                            ? [1, "week"]
                            : this.data.payFrequency === Frequencies.FORTNIGHTLY
                                ? [2, "weeks"]
                                : [1, "month"];

                    const graceDays = 3;

                    let missing = 0;
                    let next = last.add(...jumps);

                    while (next.add(graceDays, "days").isBefore(today)) {
                        missing++;
                        next = next.add(...jumps);
                    }

                    return missing;
                })();

                if (missingPayslipsBetweenMostRecentAndNow) {
                    // is there an available payslip we dont have?
                    problems.push(new problem({
                        type: "USER_ALERT",
                        enum: 'NOT_ENOUGH_PAYSLIPS',
                        title: 'More Payslips Needed',
                        body: `Upload ${missingPayslipsBetweenMostRecentAndNow} payslip(s) between the last payslip and today. Please upload the missing payslips.`,
                    }))
                } else {
                    let numberRequired
                    // if (this.data?.usingShareSaveAmount || this.data?.usingAvcAmount) {
                    //     // always same as savings rate needs, 7 months worth of payslips
                    //     numberRequired = this.payslipsInMonths(7, this.data.payFrequency)
                    // } else {
                        switch (this.mortgage.activeSubmission.lenderCode) {
                            case "ptsb":
                                numberRequired = 2
                                break;
                            case "ics":
                                numberRequired = 3
                                break;
                            case "haven":
                                numberRequired = 3
                                break;
                            case "boi":
                                numberRequired = this.payslipsInMonths(2, this.data.payFrequency)
                                break;
                            case "nua":
                                numberRequired = this.payslipsInMonths(1, this.data.payFrequency)
                                break;
                            default:
                                numberRequired = this.payslipsInMonths(1, this.data.payFrequency)
                        }
                    // }
                    // do we have the min amount of payslips for the frequency?


                    /*
                    52 weeks in a year. 26 weeks in 6 months. 13 weeks in 3 months - 13 payslips for weekly. 7 payslips for fortnightly. KC google chat 30/07/2025
                     */

                    if (activeUploads.length < numberRequired) {
                        problems.push(new problem({
                            type: "USER_ALERT",
                            enum: 'NOT_ENOUGH_PAYSLIPS',
                            title: 'Not Enough Payslips',
                            body: `We only have ${activeUploads.length} payslips, but we need at least the last ${numberRequired}`,
                        }))
                    }
                }
                // else {
                //     // check that there is not a payslip possible for last month
                //     const today = dayjs();
                //    // const lastMonth = today.subtract(1, 'month').endOf('month');
                //     const cutoffDate = today.subtract(5, 'day');
                //
                //     const lastPayslipDate = activeUploads.reduce((latest, upload) => {
                //         const uploadDate = upload.values.documentDate;
                //         return (!latest || uploadDate.isAfter(latest)) ? uploadDate : latest;
                //     }, null);
                //
                //     if (lastPayslipDate.isAfter(cutoffDate)) {
                //         return [];
                //     }
                //
                //     const frequency = this.data.payFrequency || "MONTHLY";
                //     let unit;
                //     switch (frequency) {
                //         case "WEEKLY":
                //             unit = "week";
                //             break;
                //         case "FORTNIGHTLY":
                //             // 2 weeks, so treat as weeks but divide later
                //             unit = "week";
                //             break;
                //         case "MONTHLY":
                //             unit = "month";
                //             break;
                //         default:
                //             throw new Error("Invalid frequency");
                //     }
                //     let diff = cutoffDate.diff(lastPayslipDate, unit);
                //     // Adjust for fortnightly (every 2 weeks)
                //
                //     if (frequency === "FORTNIGHTLY") {
                //         diff = Math.floor(diff / 2);
                //     }
                //
                //     if (diff > 0){
                //         problems.push(new problem({
                //             type: "USER_ALERT",
                //             enum: 'MISSING_RECENT_PAYSLIP',
                //             title: 'Missing Recent Payslip',
                //             body: `The most recent payslip we have is from ${lastPayslipDate.format('DD/MM/YYYY')}. We need ${diff} more.`,
                //         }) )
                //     }


            }
        }
        return problems
    }

    getSectionSummary = () => {
        const factor = (() => {
                switch (this.data?.payFrequency) {
                    case Frequencies.WEEKLY:
                        return 52
                    case Frequencies.FORTNIGHTLY:
                        return this.data?.publicSector ? 26.09 : 26
                    case Frequencies.MONTHLY:
                        return 12
                    case Frequencies.QUARTERLY:
                        return 4
                    case Frequencies.YEARLY:
                        return 1
                    default:
                        return 0
                }
            }
        )()
        const mostRecentPayslipWithPensionFigure = this.verifiableUploads.filter(u => u.values && u.values.pensionDeduction && u.values.documentDate).sort((a, b) => {
            return b.values.documentDate.diff(a.values.documentDate)
        })[0]
        const yearlyPensionDeduction = mostRecentPayslipWithPensionFigure?.values?.pensionDeduction ? Math.round(mostRecentPayslipWithPensionFigure.values.pensionDeduction * factor * 100) / 100 : null
        const allVerifiableUploadsWithGrossBasicFigures = this.verifiableUploads.filter(u => u.values && u.values.grossBasic && u.values.documentDate).sort((a, b) => {
            return b.values.documentDate.diff(a.values.documentDate)
        })
        const averageGrossBasic = allVerifiableUploadsWithGrossBasicFigures.length ? Math.round(allVerifiableUploadsWithGrossBasicFigures.reduce((sum, u) => sum + u.values.grossBasic, 0) / allVerifiableUploadsWithGrossBasicFigures.length * 100) / 100 : null

        const yearlyGrossBasic = averageGrossBasic ? Math.round(averageGrossBasic * factor * 100) / 100 : null

        // const estimatedYearlyBasic =
        return [
            {
                name: this.personalTitle,
                tags: [{
                    name: 'Yearly Pension Deduction',
                    value: yearlyPensionDeduction
                },
                    {
                        name: 'Average Gross Basic',
                        value: averageGrossBasic
                    },
                    {
                        name: 'Yearly Gross Basic',
                        value: yearlyGrossBasic
                    }]
            }
        ]
    }
}